import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { HEADER_ROW_HEIGHT } from '../../utils/boardHelpers';
import { formatMonthLabel, type MonthSpan } from './timelineHeaderHelpers';

interface TimelineMonthRowProps {
  monthSpans: MonthSpan[];
  dayWidth: number;
  isLast: boolean;
}

export const TimelineMonthRow = memo(function TimelineMonthRow({ monthSpans, dayWidth, isLast }: TimelineMonthRowProps) {
  const { i18n } = useTranslation();
  return (
    <div
      style={{
        position: 'relative',
        height: HEADER_ROW_HEIGHT,
        borderBottom: isLast ? undefined : '1px solid #f1f5f9',
      }}
    >
      {monthSpans.map((span) => {
        const width = (span.endDay - span.startDay) * dayWidth;
        const isJan = span.month === 0;
        return (
          <div
            key={`month-${span.year}-${span.month}`}
            style={{
              position: 'absolute',
              left: span.startDay * dayWidth,
              top: 0,
              width,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11,
              fontWeight: 600,
              color: isJan ? '#3b82f6' : '#475569',
              borderRight: isJan ? '2px solid #3b82f6' : '1px solid #e2e8f0',
              backgroundColor: isJan ? 'rgba(59, 130, 246, 0.05)' : span.month % 2 === 0 ? 'rgba(0, 0, 0, 0.02)' : 'transparent',
            }}
          >
            {formatMonthLabel(span.month, span.year, width, i18n.language)}
          </div>
        );
      })}
    </div>
  );
});
